import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import cx from "classnames";

import SectionTitleWidget from "../../../../components/SectionTitleWidget/SectionTitleWidget";
import { getUserTimezone, hasItems } from "../../../../helpers/Utils";

import s from "./CodiaxDataPage.module.scss";
import ts from "../../../../components/tables/Table.module.scss";

export default function CodiaxDataTable({ data }) {
	const sizePerPage = 1000;
	const totalPagesCount = Math.ceil(data.length / sizePerPage);
	const columns = hasItems(data) ? Object.keys(data[0]) : [];

	// ------------------------------------- METHODS -------------------------------------
	const columnFormatter = (cell) => {
		return (
			<div className={ts.rightsCell}>
				<span>{cell}</span>&nbsp;
			</div>
		);
	};

	const onSortById = (a, b, order) => {
		return order === "asc" ? a.id - b.id : b.id - a.id;
	};
	// ------------------------------------- END METHODS -------------------------------------

	const options = {
		defaultSortName: "id",
		defaultSortOrder: "asc",
		sizePerPage: sizePerPage,
		hideSizePerPage: true,
		prePage: "< Previous", // Previous page button text
		nextPage: "Next >", // Next page button text
		withoutNoDataText: true,
	};

	return (
		<div className={s.root}>
			<div className={s.section}>
				<SectionTitleWidget
					title="Attendees"
					className={s.sectionTitle}
				/>

				<div className={ts.root}>
					<BootstrapTable
						className={cx(ts.weavetable, "weave-scrollable-table", "dark")}
						pagination={totalPagesCount > 1}
						options={options}
						data={data}
						version="4"
						trClassName={ts.darkTableRow}
					>
						{hasItems(columns) &&
							columns.map((columnName, index) => {
								const isIDColumn = columnName === "id" || columnName === "ID";
								return (
									<TableHeaderColumn
										key={index}
										isKey={isIDColumn}
										dataField={columnName}
										width={isIDColumn ? "100" : "200"}
										dataSort
										sortFunc={isIDColumn ? onSortById : null}
										dataFormat={columnFormatter}
									>
										{columnName === "timestamp"
											? `timestamp ${getUserTimezone()}`
											: columnName}
									</TableHeaderColumn>
								);
							})}
					</BootstrapTable>
				</div>
			</div>
		</div>
	);
}
